import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CalendarIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * プロジェクト事例の期間を表示するコンポーネント
 * @constructor
 */
export const CSearchSolutionPeriodIconText = (props) => {
    const { className = '', period } = props;
    return (_jsxs(IconTextGroup, Object.assign({ className: className, space: 'wide' }, { children: [_jsx(CalendarIcon, { color: 'base', size: 'sm' }), _jsx(Text, Object.assign({ className: 'whitespace-nowrap !leading-none', isBold: true, size: 'sm' }, { children: `約${period}週間` }))] })));
};
